import { NgModule } from '@angular/core';

import { CoreMenuComponent } from 'app/back-office/layout/core-menu/core-menu.component';

/**
 * Wrapper di compatibilità: i componenti del core-menu sono standalone.
 * Il modulo resta solo per i molti moduli feature che lo importano.
 */
@NgModule({
  imports: [CoreMenuComponent],
  exports: [CoreMenuComponent]
})
export class CoreMenuModule { }
